var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import camelcaseKeys from 'camelcase-keys';
import { stringify } from 'query-string';
import toSnakeCase from 'to-snake-case';
import urlJoin from 'url-join';
import { getFormatDatetimeString } from '@/helpers/common';
import { mapObj } from '@/helpers/common/ArrayHelper';
import { CREATE, DELETE, GET_LIST, GET_ONE, UPDATE } from './types';
export default (apiBaseUrl, apiCaller) => {
    const buildUrl = (type, payload, apiPath, meta) => {
        const { isObjectUpload } = meta;
        const setUrl = apiBaseUrl;
        if (isObjectUpload) {
            return apiPath;
        }
        switch (type) {
            case GET_LIST: {
                // ページネーション、ソート、検索クエリなどの条件指定を取得
                const query = payload.params;
                return urlJoin(setUrl, apiPath, `?${stringify(query)}`);
            }
            case GET_ONE:
            case CREATE:
            case UPDATE:
            case DELETE: {
                return urlJoin(setUrl, apiPath);
            }
            default: {
                throw new Error(`Unsupported fetch action type ${type}`);
            }
        }
    };
    const buildOptions = (type, payload, meta) => __awaiter(void 0, void 0, void 0, function* () {
        const { headers, isBlob, isObjectUpload, isValidateOnly } = meta;
        const options = {
            headers,
            isBlob: !!isBlob,
            isObjectUpload: !!isObjectUpload,
            isValidateOnly: !!isValidateOnly,
        };
        if (isObjectUpload) {
            const fileBuffer = yield new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reader.abort();
                    reject(new Error('Problem parsing file'));
                };
                reader.readAsArrayBuffer(payload.data);
            });
            options.method = 'PUT';
            options.body = fileBuffer;
            return options;
        }
        if ((type === CREATE || type === UPDATE) && payload && payload.data) {
            switch ((headers || {})['Content-Type']) {
                case 'multipart/form-data': {
                    options.body = payload.data; // data = new FormData()
                    break;
                }
                default: {
                    // assume 'text/json'
                    const mapObjOptions = { deep: true, exclude: [] };
                    const keyMatches = (patterns, value) => patterns.some((pattern) => typeof pattern === 'string'
                        ? pattern === value
                        : pattern.test(value));
                    const sendJsonValue = mapObj(payload.data, (key, val) => [
                        keyMatches(mapObjOptions.exclude, key) ? key : toSnakeCase(key),
                        (() => {
                            if (val instanceof Date) {
                                return getFormatDatetimeString(val);
                            }
                            return val;
                        })(),
                    ], mapObjOptions);
                    options.body = JSON.stringify(sendJsonValue);
                }
            }
        }
        switch (type) {
            case GET_LIST:
            case GET_ONE: {
                break;
            }
            case CREATE: {
                options.method = 'POST';
                break;
            }
            case UPDATE: {
                options.method = 'POST';
                break;
            }
            case DELETE: {
                options.method = 'DELETE';
                break;
            }
            default: {
                throw new Error(`Unsupported fetch action type ${type}`);
            }
        }
        return options;
    });
    const convertRequest = (type, payload, meta) => __awaiter(void 0, void 0, void 0, function* () {
        const { apiPath, device, onUploadProgress } = meta;
        const url = buildUrl(type, payload, apiPath, meta);
        const defaultOption = yield buildOptions(type, payload, meta);
        const options = Object.assign(Object.assign({}, defaultOption), { device,
            onUploadProgress });
        return { options, url };
    });
    /**
     * レスポンスの整形を行う
     * @param type
     * @param response
     * @param meta
     * @returns {{total: number, code: *, data: *, lastPage: number, userDevice, body, message: *, currentPage: number}}
     */
    const convertResponse = (type, response, meta) => {
        const { body, headers, json: responseJson } = response;
        /** responseのjsonの値がnullの場合を想定する */
        const json = responseJson || {};
        // いずれはキャメルケース変換を全廃したい
        const data = meta.isSnakeCase
            ? json.data
            : camelcaseKeys(json.data, { deep: true });
        const { code, message } = json;
        let total = 0;
        let currentPage = 0;
        let lastPage = 0;
        const xDataLength = headers['x-data-Length'];
        const xCurrentPage = headers['x-current-page'];
        const xTotalPage = headers['x-total-page'];
        const userDevice = headers['x-user-device'];
        const contentRange = headers['content-range'];
        if (typeof xDataLength === 'string') {
            total = parseInt(xDataLength, 10);
        }
        else if (typeof contentRange === 'string') {
            const regexContentRange = /^(\d+)-(\d+)\/(\d+)$/;
            const matched = contentRange.match(regexContentRange);
            total = parseInt(matched[3], 10);
        }
        else if (Array.isArray(json)) {
            total = json.length;
        }
        if (typeof xCurrentPage === 'string') {
            currentPage = parseInt(xCurrentPage, 10);
        }
        if (typeof xTotalPage === 'string') {
            lastPage = parseInt(xTotalPage, 10);
        }
        return {
            body,
            code,
            currentPage,
            data,
            lastPage,
            message,
            total,
            userDevice,
        };
    };
    return (type, payload, meta) => __awaiter(void 0, void 0, void 0, function* () {
        const { options, url } = yield convertRequest(type, payload, meta);
        const response = yield apiCaller(type, url, options, meta);
        return convertResponse(type, response, meta);
    });
};
